<div class="icon_lclose">
  <mat-dialog-actions align="end">
    <button type="button" [attr.aria-label]="'common.actions.close' | translate" mat-icon-button mat-dialog-close (keyup.esc)="onWindowsKey($event)">
      <mat-icon>
        close
      </mat-icon>
    </button>
  </mat-dialog-actions>
</div>

<div class="title_ d-flex align-items-center justify-content-between ">
  <!-- <div class="d-flex ">
    View Report
  </div> -->
  <div class="d-flex ">
    <mat-slide-toggle [disabled]="loading" (change)="changeToogle($event)">
      <span style="min-width: 90px; width: 100%; display: flex;">

        {{ (showNormal ? 'common.dialog.row.toggle.normal' : 'common.dialog.row.toggle.extraInfo') | translate }}

      </span>
    </mat-slide-toggle>
  </div>
</div>

<div class="container_dialog__ justify-content-center">

  <div class="row_list_product align-items-center flex-column d-flex w-100">
    <div class="d-flex ">
      <h5>{{ 'common.dialog.row.watching' | translate }}</h5>
    </div>
    <div class="d-flex detail_product" *ngIf="row && row.id && row.product && row.product.id">
      <table class="table" style="color:var(--g15-on-surface);">
        <thead>
        <tr>
          <th scope="col">{{ 'common.image' | translate }}</th>
          <th scope="col">{{ 'common.product' | translate }}</th>
          <th scope="col">{{ 'common.brand' | translate }}</th>
          <th *ngIf="!filter.groupByValue" scope="col">{{ 'common.extraInfo' | translate }}</th>
          <th scope="col">{{ 'common.quantity' | translate }}</th>
          <th scope="col">{{ 'common.total' | translate }}</th>
          <th scope="col">{{ 'common.priceRules' | translate }}</th>

        </tr>
        </thead>
        <tbody>
        <tr class="custom_tr">
          <th scope="row">


              <!-- A real <button>, not an <img (click)>: the picture opens the enlarged preview, so
                   it needs a tab stop, Enter/Space and a role (WCAG 2.1.1 / 4.1.2; refused by
                   `npm run audit:pointeronly`). Named for what it does; the inner <img> is then
                   decorative, so the product's name is not read twice. -->
              <!-- Name resolved once, used for the aria-label AND the tooltip (same string, so CDK
                   does not describe the control a second time); (detach) resyncs isOpen however the
                   overlay closed -- CDK detaches on Escape by itself. -->
              <ng-container *ngIf="{ name: row['product'].cardData | localizedName } as c">
              <ng-container *ngIf="{ label: c.name ? ('common.actions.enlargeImageNamed' | translate: { name: c.name }) : ('common.actions.enlargeImage' | translate) } as v">
              <button type="button" class="g15-img-control" #trigger="cdkOverlayOrigin" cdkOverlayOrigin
                      (click)="isOpen = !isOpen; $event.stopPropagation()" [attr.aria-expanded]="isOpen"
                      [attr.aria-label]="v.label" [matTooltip]="v.label">
                <img [src]="row['product'].cardData.image | appImageUrl" width="105" alt="">
              </button>

              
              <ng-template #cdkConOverlay="cdkConnectedOverlay" cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOpen" (detach)="isOpen = false">

                <div class="d-flex panel_onfire justify-content-center flex-column align-items-center w-100">

                  <div class="d-flex w-100" style="max-width: 200px;">

                    <img [src]="row.product.cardData.image | appImageUrl" [alt]="c.name || ''" width="200">

                  </div>

                </div>
              </ng-template>
              </ng-container>
              </ng-container>

            <!--<ng-template #cdkConOverlay="cdkConnectedOverlay" cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger"
                         [cdkConnectedOverlayOpen]="isOpen" >

              <div class="d-flex panel_onfire justify-content-center flex-column align-items-center w-100">

                <div class="d-flex w-100" style="max-width: 200px;">

                  <img [src]="row.product.cardData.image | appImageUrl" [alt]="row.product.cardData.name" width="200">

                <div class="d-flex panel_onfire justify-content-center flex-column align-items-center w-100">

                  <div class="d-flex w-100" style="max-width: 200px;">

                    <img [src]="row.product.cardData.image | appImageUrl" [alt]="row.product.cardData.name" width="200">

                  </div>

                </div>

              </div>

            </ng-template>-->


            </th>
            <td>
              <span>
                {{row.product.cardData | localizedName}}

              </span>
            </td>
            <td>
              <span>
                {{row.product.brand.name}}

              </span>
          </td>

            <td *ngIf="!filter.groupByValue">
              <span>
                {{row.product.expansion.englishName}}

              </span>
            </td>

            <td>
              <span>
                {{row.totalQuantity}}
              </span>
          </td>

            <td>
              <span>
                {{row.stockTotal}}
              </span>
          </td>

            <td>
              <span>
                <cdk-virtual-scroll-viewport itemSize="20" #vp class="example-viewport" [ngStyle]="{'height': '150px'    }  "  >
                  <div  *cdkVirtualFor="let item of row.priceRules" #container_item_sc  class="example-item"  >

                    <a  target="_blank" [href]="getUrl(item.ruleId)" (click)="$event.stopPropagation();" class="list_link list_link_ho overflow-hidden">
                      {{item.productName}}
                    </a>

                  </div>
                </cdk-virtual-scroll-viewport>
              </span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<hr>

<ng-container *ngIf="!loading ; else noLoading">
  <ng-container *ngIf="defaultListConf">
    <ng-container *ngIf="showNormal; else NoNormal">
      <app-table  (status)="tableStatusChangeCart($event)" [displayedColumns]="defaultListConf.displayedColumns"
        [config]="defaultListConf.tableConfig" [dataSource]="dataSource"  class="table_onDialog_report" >
      </app-table>
    </ng-container>
    <ng-template #NoNormal>
      <app-table (status)="tableStatusChangeCartNoExtra($event)"  [displayedColumns]="defaultListConf.displayedColumns"
        [config]="defaultListConf.tableConfig" [dataSource]="dataSource" class="table_onDialog_report">
      </app-table>
    </ng-template>

  </ng-container>
</ng-container>

<ng-template #noLoading>
  <div class="d-flex align-items-center justify-content-center w-100 h-100">
    <mat-spinner color="primary"></mat-spinner>
  </div>
</ng-template>
